import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from '../../../../../../../../store/axiosInstance';
import Header from '../../../../../RMS/Components/Layout/Header';
import { SERVER_URL } from '../../../../../../../../Config/config';
import "../../../Style/Style.css";
import Loader from '../../../../../Landing/DNA/DnaResult/Loader';

function SkillsPage() {
  const { state } = useLocation();
  const navigate = useNavigate();



  const [skills, setSkills] = useState(state?.skills?.skills || {});
  const [categories, setCategories] = useState(state?.skills?.categories || []);
  const [existingSkills, setExistingSkills] = useState(state?.skills?.existingSkills || []);
  const [careerGoal, setCareerGoal] = useState(state?.skills?.careerGoal || 'Unknown');
  const [selectedSkills, setSelectedSkills] = useState(
    state?.skills?.categories?.reduce((acc, cat) => ({ ...acc, [cat]: [] }), {}) || {}
  );
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

     const [roadmaps, setRoadmaps] = useState([]);

  useEffect(() => {
    const fetchRoadmaps = async () => {
      try {
        const res = await axiosInstance.get(`${SERVER_URL}/api/v1/career-gpt/get-roadmaps`);
        setRoadmaps(res.data);
      } catch (error) {
        console.error('Failed to fetch roadmaps:', error);
      }
    };

    fetchRoadmaps();
  }, []);

  console.log('SkillsPage state:', state);

  // useEffect(() => {
  //   if (!state?.skills?.skills || !state?.skills?.categories) {
  //     setError('No skills data available. Please submit a career goal first.');
  //   } else {
  //     setSkills(state.skills.skills);
  //     setCategories(state.skills.categories);
  //     setExistingSkills(state.skills.existingSkills || []);
  //     setCareerGoal(state.skills.careerGoal || 'Unknown');
  //     setSelectedSkills(
  //       state.skills.categories.reduce((acc, cat) => ({ ...acc, [cat]: [] }), {})
  //     );
  //   }
  // }, [state]);

  const currentCategory = categories[currentCategoryIndex] || '';

  const handleSkillSelect = (skill, category) => {
    setSelectedSkills((prev) => ({
      ...prev,
      [category]: prev[category].includes(skill)
        ? prev[category].filter((s) => s !== skill)
        : [...prev[category], skill],
    }));
  };

  const handleSuggest = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post('/api/v1/career-gpt/skills/suggest', {
        selectedSkills,
        currentCategory,
        careerGoal,
      });
      setSkills((prev) => ({
        ...prev,
        [currentCategory]: [...new Set([...(prev[currentCategory] || []), ...response.data.suggestedSkills])],
      }));
    } catch (error) {
      setError('Error suggesting skills: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (currentCategoryIndex < categories.length - 1) {
      setCurrentCategoryIndex(currentCategoryIndex + 1);
    } else {
      handleGenerateRoadmap();
    }
  };

  const handleGenerateRoadmap = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post('/api/v1/career-gpt/roadmap', {
        selectedSkills,
        careerGoal,
      });
      console.log('Roadmap response:', response.data);
      setSelectedSkills(categories.reduce((acc, cat) => ({ ...acc, [cat]: [] }), {}));
      // navigate('/roadmap', { state: { roadmap: response.data, skills: state.skills } });
            navigate('/career-gpt/career-roadmap', { state: { roadmap: response.data, skills: state.skills } });

    } catch (error) {
      setError('Error generating roadmap: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };




const [currentStep, setCurrentStep] = useState(1);

const handleNextButton = () => {
  if (currentStep < 4) {
    setCurrentStep((prev) => prev + 1);
  }
};



  const handleNavigate = (item) => {
    const content = JSON.parse(item.content || '{}');
    const skills = content.skillMatch?.matchedSkills || []; 
    navigate('/career-gpt/career-roadmap', {
      state: {
      roadmap: {
        roadmap: content,
      },
        skills,
      },
    });
  };

  const formatAMPM = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${minutes} ${ampm}`;
};

const now = new Date();
// const formattedTime = `Today, ${formatAMPM(now)}`;

  const formatMessageTime = (date) => {
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const isYesterday =
    new Date(now.setDate(now.getDate() - 1)).toDateString() === date.toDateString();

  const time = formatAMPM(date);
  return isToday ? `Today, ${time}` : isYesterday ? `Yesterday, ${time}` : date.toLocaleString();
};

const formattedTime = formatMessageTime(new Date());


  return (
    <div>
    {/* <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-indigo-600 to-blue-500 p-6">
            <h1 className="text-2xl sm:text-3xl font-bold text-white text-center">
              Career Goal: {careerGoal}
            </h1>
          </div>
          <div className="p-6 space-y-6">
            {existingSkills.length > 0 && (
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Your Existing Skills</h3>
                <div className="flex flex-wrap gap-2">
                  {existingSkills.map((skill) => (
                    <span
                      key={skill}
                      className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            )}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-800">
                Select {currentCategory.charAt(0).toUpperCase() + currentCategory.slice(1)} Skills
              </h2>
              <span className="text-sm text-gray-500">
                Step {currentCategoryIndex + 1} of {categories.length}
              </span>
            </div>
            {error && (
              <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                <p className="text-sm font-medium">{error}</p>
                <button
                  onClick={() => navigate('/')}
                  className="mt-2 text-red-700 underline hover:text-red-800"
                >
                  Go back to submit a career goal
                </button>
              </div>
            )}
            {loading && (
              <div className="flex items-center justify-center space-x-3">
                <svg className="animate-spin h-6 w-6 text-indigo-600" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z" />
                </svg>
                <p className="text-gray-600">Loading...</p>
              </div>
            )}
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {skills[currentCategory]?.length > 0 ? (
                skills[currentCategory].map((skill) => (
                  <button
                    key={skill}
                    onClick={() => handleSkillSelect(skill, currentCategory)}
                    className={`w-full text-left p-3 rounded-lg shadow-sm transition-colors duration-200 ${
                      selectedSkills[currentCategory]?.includes(skill)
                        ? 'bg-indigo-100 text-indigo-800'
                        : 'bg-gray-50 text-gray-700 hover:bg-indigo-50'
                    }`}
                    disabled={loading}
                  >
                    {skill}
                  </button>
                ))
              ) : (
                <p className="text-gray-500 text-sm">
                  No skills available. Click "Suggest More" to get recommendations.
                </p>
              )}
            </div>
            <div className="flex justify-between gap-4">
              <button
                onClick={handleSuggest}
                className={`flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors duration-300 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                Suggest More
              </button>
              <button
                onClick={handleNext}
                className={`flex-1 bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors duration-300 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                {currentCategoryIndex === categories.length - 1 ? 'Generate Roadmap' : 'Next'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> */}



    <div className="bg-black  font-bricolage h-screen text-white overflow-hidden overflow-y-auto bg-cover">
             <div className="bg-Fabcbg bg-cover bg-center w-full h-full ">
               <Header />
               <div className="relative">
              <div className="absolute w-full flex justify-between z-0">
                <div
                  style={{
                    background:
                      'radial-gradient(50% 50% at 50% 50%, rgba(158, 110, 230, 0.28) 0%, rgba(158, 110, 230, 0) 100%)',
                  }}
                  className="w-[35rem] h-[35rem] opacity-45 blur rounded-full z-0 "
                ></div>
                <div
                  style={{
                    background:
                      'radial-gradient(50% 50% at 50% 50%, rgba(92, 195, 250, 0.28) 0%, rgba(92, 195, 250, 0) 100%)',
                  }}
                  className="w-[35rem] h-[35rem] opacity-45 blur rounded-full z-0 "
                ></div>
              </div>
    <div className="  p-6 flex flex-col md:flex-row gap-6">
      <aside className="md:w-1/4 z-30 bg-[#D9D9D90D] border border-[#3EE6F93B] rounded-xl p-4">
        <div className=" mb-6"> <h1 className="text-3xl text-center font-bold">
          Career<span className="text-[#FF2857]">GPT</span>
        </h1>
        <p className=' text-xs text-center '>Powered by AIFA</p>
        </div>

        <div>
          <img src='/assets/Mascots/CareerGptMascot.svg' className=' w-5/12 mx-auto ' />
        </div>

        <div className="mt-8">
          <h3 className="text-sm mb-2">Past Search:</h3>
          <ul className="space-y-5 text-sm text-gray-300 h-72 overflow-y-auto ">
          {roadmaps.map((item) => {
          const content = JSON.parse(item.content || '{}');
          const job = item.jobRole || content.profileDescription?.split('.')[0] || 'Unknown Role';
          const progress = (content.skillMatch?.overallMatchPercentage || 0) + '%';

          return (
            <li key={item.id}
              className="cursor-pointer bg-[#D9D9D91C] border border-white rounded-2xl text-center px-3 py-1 transition hover:bg-white/10"

              onClick={() => handleNavigate(item)}
               >
              <p title={job} className=' truncate '>{job}</p>
              <div className='mt-3 mb-2 bg-[#D9D9D91C] border border-white/30 rounded-full w-full'>
                <div className='h-1.5 bg-[#10F2EEAD] rounded-full' style={{ width: progress }}></div>
              </div>
            </li>
          );
        })}
          </ul>
        </div>
      </aside>

      {/* Main Chatbot Area */}
      <main className="flex-1 bg-[#D9D9D90D] border border-[#3EE6F93B] rounded-xl p-6 space-y-6">

        <div className=' flex justify-end gap-3 '>
          <div>
        <div className=' bg-[#0EA4A980] rounded-t-2xl rounded-bl-2xl p-3 '>
            <p>{careerGoal}</p>
        </div>
          <span className="text-xs text-right mt-2 text-gray-400 block">{formattedTime}</span>
          </div>

        
        <div className=' translate-y-7 '>
           <img src='/assets/Mascots/mas5.svg' className=' w-8 ' />
        </div>
        </div>

        {/* Message Block 1 */}
        <div className="lg:w-[60%] w-full border border-[#00F7EB] rounded-t-xl rounded-br-xl p-4 space-y-2">
          <p>
           Hi there I’m AIFA, happy to see you here As per you you’re looking for a frontend developer for the customized roadmap kindly answer the following questions
          </p>
        </div>
          <span className="text-xs text-gray-400">{formattedTime}</span>


        {/* Message Block 2 */}
        {/* <div className="lg:w-[60%] w-full z-30 border border-[#00F7EB] rounded-t-xl rounded-br-xl p-4 space-y-4">
          <p>
            Since Frontend includes various skills and tools kindly choose your preferred primary skills.
          </p>
          <div className="flex flex-wrap gap-3">
            {Array(2).fill(skillsset).flat().map((skill, i) => (
              <button
                key={i}
                className="bg-[#D9D9D91C] z-30 px-4 py-2 rounded-full text-sm hover:bg-[#444]/70 "
              >
                {skill}
              </button>
            ))}
          </div>
          <p>
            If you struggle to choose the option I can suggest you, kindly let me know.
          </p>
          <div className=' z-30 flex justify-center '>
      <button className=" z-30 bg-[#D9D9D91C] mx-auto italic px-4 py-2 rounded-full text-sm hover:bg-[#444]/70 ">
            Suggest me
          </button>
          </div>
        </div> */}

        <div className="lg:w-[60%] w-full z-30 border border-[#00F7EB] rounded-t-xl rounded-br-xl p-4 space-y-4">
  <p>
    Since  various skills and tools kindly choose your preferred primary skills.
  </p>

   <div className="flex justify-between items-center z-30">
              <h2 className=" font-semibold ">
                Select {currentCategory.charAt(0).toUpperCase() + currentCategory.slice(1)} Skills
              </h2>
              <span className="text-sm text-gray-500">
                Step {currentCategoryIndex + 1} of {categories.length}
              </span>
            </div>
             {error && (
              <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                <p className="text-sm font-medium">{error}</p>
                <button
                  onClick={() => navigate('/')}
                  className="mt-2 text-red-700 underline hover:text-red-800"
                >
                  Go back to submit a career goal
                </button>
              </div>
            )}
            {loading && (
              <div className=' fixed inset-0 flex items-center justify-center bg-black/85 z-50'>
<div class="loader-wrapper">
  <span class="loader-letter">G</span>
  <span class="loader-letter">e</span>
  <span class="loader-letter">n</span>
  <span class="loader-letter">e</span>
  <span class="loader-letter">r</span>
  <span class="loader-letter">a</span>
  <span class="loader-letter">t</span>
  <span class="loader-letter">i</span>
  <span class="loader-letter">n</span>
  <span class="loader-letter">g</span>

  <div class="loader"></div>
</div>
</div>

              // <div className="flex items-center justify-center space-x-3">
              //   <svg className="animate-spin h-6 w-6 text-indigo-600" viewBox="0 0 24 24">
              //     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              //     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z" />
              //   </svg>
              //   <p className="text-gray-600">Loading...</p>
              // </div>
            )}
             {/* <div className="flex flex-wrap gap-3">
              {skills[currentCategory]?.length > 0 ? (
                skills[currentCategory].map((skill) => {
                  <button
                    key={skill}
                    onClick={() => handleSkillSelect(skill, currentCategory)}
                    className={`bg-[#D9D9D91C] z-30 px-4 py-2 rounded-full text-sm hover:bg-[#444]/70  transition-colors text-white duration-200 z-30 ${
                      selectedSkills[currentCategory]?.includes(skill)
                        ? ' bg-[#0EA4A980] text-white '
                        : 'bg-[#D9D9D91C]  hover:bg-indigo-50'
                    }`}
                    disabled={loading}
                  >
                    {skill}
                  </button>
})
              ) : (
                <p className="text-gray-500 text-sm">
                  No skills available. Click "Suggest More" to get recommendations.
                </p>
              )}
            </div> */}
            <div className="flex flex-wrap gap-3">
  {skills[currentCategory]?.length > 0 &&
    skills[currentCategory].map((skill) => (
      <button
        key={skill}
        onClick={() => handleSkillSelect(skill, currentCategory)}
        disabled={loading}
        className={`z-30 px-4 py-2 rounded-full text-sm text-white transition-colors duration-200
          ${selectedSkills[currentCategory]?.includes(skill)
            ? 'bg-[#0EA4A980]'
            : 'bg-[#D9D9D91C] hover:bg-[#444]/70'}
        `}
      >
        {skill}
      </button>
    ))}
</div>

            <p>
    If you struggle to choose the option I can suggest you, kindly let me know.
  </p>
             <div className="w-[80%] mx-auto flex justify-between gap-5 ">
              <button
                onClick={handleSuggest}
                className={`w-1/2 z-30 bg-[#D9D9D91C] italic px-4 py-2 rounded-full text-sm hover:bg-[#444]/70 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                Suggest More
              </button>
              <button
                onClick={handleNext}
                className={`w-1/2 z-30 border border-[#00F7EB] px-4 py-2 rounded-full text-sm font-semibold hover:opacity-90 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                {currentCategoryIndex === categories.length - 1 ? 'Generate Roadmap' : 'Next'}
              </button>
            </div>


  {/* <div className="flex flex-wrap gap-3">
    {Array(2).fill(skillsset).flat().map((skill, i) => (
      <button
        key={i}
        className="bg-[#D9D9D91C] z-30 px-4 py-2 rounded-full text-sm hover:bg-[#444]/70 "
      >
        {skill}
      </button>
    ))}
  </div> */}

  {/* <p>
    If you struggle to choose the option I can suggest you, kindly let me know.
  </p> */}

  {/* Button Row */}
  {/* <div className="z-30 flex justify-center gap-4 mt-2">
    <button className="z-30 bg-[#D9D9D91C] italic px-4 py-2 rounded-full text-sm hover:bg-[#444]/70">
      Suggest me
    </button>
    <button onClick={handleNextButton} className="z-30 bg-[#00F7EB] text-black px-4 py-2 rounded-full text-sm font-semibold hover:opacity-90">
      Next
    </button>
  </div> */}
</div>
          <span className="text-xs text-gray-400 ">{formattedTime}</span>
      </main>
    </div>
    </div>
    </div>
    </div>


    </div>
  );
}

export default SkillsPage;
